const convertCamelStringToDashCase = (string) =>
  string
    .replace(/[A-Z]/g, (c) => "-" + c.toLowerCase())
    .replace(/^-/, "")
    .replace(/--/g, "-");

export default convertCamelStringToDashCase;
